<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //contents_head -->
            <div :style="{ display: mode === 'list' ? 'block' : 'none' }">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w100">
                                <li class="tit_200">{{ $t('FIELD.COUNTRY.NAME') }}</li>
                                <li data-input-type="text" class="w100-200">
                                    <fieldset class="ui_fieldset set_3">
                                        <div>
                                            <select
                                                class="slt_white w100"
                                                v-model="country1"
                                                @change="getCountryList2()"
                                                disabled
                                            >
                                                <option
                                                    v-for="item in countryList1"
                                                    :key="'countryList1' + item.code"
                                                    :value="item.code"
                                                >
                                                    {{ item.codeName }}
                                                </option>
                                            </select>
                                        </div>
                                        <div>
                                            <select
                                                class="slt_white w100"
                                                v-model="country2"
                                                @change="getCountryList3()"
                                                disabled
                                            >
                                                <option
                                                    v-for="item in countryList2"
                                                    :key="'countryList2' + item.code"
                                                    :value="item.code"
                                                >
                                                    {{ item.codeName }}
                                                </option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100" v-model="country3">
                                                <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                <option
                                                    v-for="item in countryList3"
                                                    :key="'countryList3' + item.code"
                                                    :value="item.code"
                                                >
                                                    {{ item.codeName }}
                                                </option>
                                            </select>
                                        </div>
                                    </fieldset>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_200">
                                    {{ $t('FIELD.GLOBAL.INQUIRY.TYPE') }}
                                </li>
                                <li data-input-type="text" class="w100-200">
                                    <select class="slt_white w100p" v-model="vocInquiry">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in vocInquiryList"
                                            :key="'vocInquiryList' + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_200">{{ $t('FIELD.VOC.STATUS') }}</li>
                                <li data-input-type="text" class="w100-200">
                                    <select class="slt_white w100p" v-model="vocStatus">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in vocStatusList"
                                            :key="'vocStatusList' + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_200">{{ $t('FIELD.GLOBAL.TITLE') }}</li>
                                <li data-input-type="text" class="w100-200">
                                    <span class="clearable">
                                        <input
                                            type="text"
                                            class="text_input w100"
                                            v-model="vocName"
                                            @keyup.enter.stop="onSearch(1)"
                                            :placeholder="$t('FIELD.GLOBAL.ETC.088')"
                                            v-clearable
                                        />
                                    </span>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_200">{{ $t('FIELD.GLOBAL.REQUEST.DATE') }}</li>
                                <li data-input-type="date" class="w100-200">
                                    <fieldset class="ui_fieldset">
                                        <span class="date-wrap">
                                            <label>
                                                <input
                                                    id="frDate"
                                                    type="text"
                                                    class="date_input w100p"
                                                    :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')"
                                                    readonly
                                                    maxlength="20"
                                                />
                                                <a href="javascript:" class="in_btn" id="icoFrDate">
                                                    <i class="ico_date"></i>
                                                    <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                                </a>
                                            </label>
                                            <div class="fr_datepicker" id="fr-picker-container" />
                                        </span>
                                        <em class="txt_space"></em>
                                        <span class="date-wrap">
                                            <label>
                                                <input
                                                    id="toDate"
                                                    type="text"
                                                    class="date_input w100p"
                                                    :placeholder="$t('FIELD.UNTIL.DATE')"
                                                    readonly
                                                    maxlength="20"
                                                />
                                                <a href="javascript:" class="in_btn" id="icoToDate">
                                                    <i class="ico_date"></i>
                                                    <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                                </a>
                                            </label>
                                            <div class="to_datepicker" id="to-picker-container" />
                                        </span>
                                    </fieldset>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR_bottom">
                            <span class="btn">
                                <a href="javascript:" class="btn_srch" @click="onSearch(1)">
                                    {{ $t('BUTTON.GLOBAL.SEARCH') }}
                                </a>
                            </span>
                        </div>
                    </article>
                </div>
                <!-- Grid -->
                <div class="grid_wrap number-cell">
                    <!-- Count -->
                    <div class="grid_total">
                        {{ $t('TITLE.TOTAL.COUNT') }} : <em>{{ totalCount | numberFormat }}</em>
                    </div>
                    <toast-grid
                        :gridId="gridId"
                        :header="header"
                        :columns="columns"
                        :data="requestList"
                        :options="options"
                        :ref="gridId"
                        :key="gridKey"
                        :isTotalCount="false"
                        :click="contentClick"
                    />
                    <div class="paginate">
                        <sdl-pagination
                            align="center"
                            :current-page="currentPage"
                            :total-rows="totalCount"
                            :per-page="nRecordsPerPage"
                            @change="onSearch"
                        />
                    </div>
                </div>
            </div>
            <request-voc-detail v-if="mode == 'view'" :data="data"></request-voc-detail>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import { EventBus } from '@/utils/EventBus';
import { SDLUtil, DateUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

require('moment-jdateformatparser');
import DatePicker from '~c/DatePicker';
import ToastGrid from '~c/ToastGrid';
import SDLPagination from '~~c/control/pagination/Pagination';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import RequestVocDetail from '~vb/eur/voc/RequestVocDetail';

export default {
    name: 'requestVocList',
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
        'skp-breadcrumbs': SKPBreadcrumbs,
        'request-voc-detail': RequestVocDetail,
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            loginRhq: 'getLoginRhq',
            loginNo: 'getLoginNo',
        }),
    },
    data() {
        return {
            pageTitle: '',
            mode: 'list',
            data: {},
            totalCount: 0,
            currentPage: 1,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            gridKey: 0,
            gridId: this.$route.name + 'Grid',
            columns: [],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: true,
                minBodyHeight: 80,
                bodyHeight: 450,
            },
            header: {
                height: 70,
                complexColumns: [],
            },
            country1: '',
            country2: '',
            country3: '',
            vocInquiry: '',
            vocStatus: '',
            vocName: '',
            countryList1: [],
            countryList2: [],
            countryList3: [],
            vocInquiryList: [],
            vocStatusList: [],
            requestList: [],
        };
    },
    methods: {
        onSearch(page) {
            this.currentPage = page;
            this.searchList();
        },
        getSearchParams() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let startDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFromDt = startDate ? moment(startDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';

            let searchParams = {
                page: this.currentPage,
                loginNo: this.loginNo,
                country1: this.country1,
                country2: this.country2,
                country3: this.country3,
                vocInquiry: this.vocInquiry,
                vocStatus: this.vocStatus,
                vocName: this.vocName,
                searchFromDt: searchFromDt,
                searchToDt: searchToDt,
            };
            return searchParams;
        },
        async searchList(v) {
            SDLUtil.showLoadingBar(true);
            let searchParams = this.getSearchParams();

            return axios
                .post(`${SDLUtil.API_URL}/basis/eur/getVocList.skp`, qs.stringify(searchParams))
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.requestList = resp.data.result.rowData;
                    for (const result of this.requestList) {
                        result.SELECT_MODEL_CODE = result.MODEL_CD;
                        if (!SDLUtil.isNull(result.NATION_NM)) {
                            result.SELECT_MODEL_CODE += '(' + result.NATION_NM + ')';
                        }
                    }
                    this.totalCount = resp.data.search.totalRecords;
                    this.gridKey++;
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        async getCommonCodeList(v) {
            const codeResp = await api.getCommonCodeList(v, 'A');
            return codeResp;
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.loginNo);
            return codeResp;
        },
        getCountryList1() {
            this.getCodeComboList(this.loginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                this.countryList1 = data;
            });
        },
        getCountryList2() {
            this.getCodeComboList(this.country1, 'SUB_AUTH_ACCESS_CD').then(data => {
                let country2 = this.country2;
                this.countryList2 = data;
                const idx = this.countryList2.findIndex(function(item) {
                    return item.code === country2;
                });
                if (0 > idx) {
                    if (0 < this.countryList2.length) {
                        this.country2 = this.countryList2[0].code;
                    } else {
                        this.country2 = '';
                    }
                }
            });
        },
        async getCountryList3() {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/eur/getNationList.skp`,
                    qs.stringify({
                        loginNo: this.loginNo,
                        corpCd: this.country2,
                        type: 'voc',
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    let country3 = this.country3;
                    let codeList = [];
                    this.countryList3 = [];
                    for (const result of resp.data.result.rowData) {
                        const idx = this.countryList3.findIndex(function(item) {
                            return item.code === result.COUNTRY_CD;
                        });
                        if (0 > idx) {
                            this.countryList3.push({ code: result.COUNTRY_CD, codeName: result.COUNTRY_NM });
                            codeList.push(result.CODE);
                        }
                    }

                    codeList = Array.from(new Set(codeList));
                    if (1 === codeList.length && !SDLUtil.isNull(codeList[0])) {
                        this.vocStatus = codeList[0];
                    }
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        contentClick(e, rowData, grid) {
            this.data = rowData[e.rowKey];
            this.mode = 'view';
        },
        newQuestion() {
            window.open(`${SDLUtil.WEB_CONTEXT_PATH}/erp/requestQuestion`);
        },
        getColumn() {
            let column = [];

            column.push({
                header: SDLUtil.getMsgProp('FIELD.VOC.NO'),
                name: 'VOC_SEQ',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.REQUEST.DATE'),
                name: 'VOC_DT',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.PENDING.DAYS'),
                name: 'PENDING_DAYS',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY.TYPE'),
                name: 'INQUIRY_TYPE_NM',
                align: 'center',
                width: 180,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.MAJOR.PRODUCT.CATEGORY'),
                name: 'CATE_MAIN_NM',
                align: 'center',
                width: 180,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.SUB.PRODUCT.CATEGORY'),
                name: 'CATE_SUB_NM',
                align: 'center',
                width: 180,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'),
                name: 'SELECT_MODEL_CODE',
                align: 'left',
                width: 250,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.TITLE'),
                name: 'TITLE',
                align: 'left',
                width: 250,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.COUNTRY.NAME'),
                name: 'COUNTRY_NM',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.BP.NUMBER'),
                name: 'BP_NO',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.VOC.STATUS'),
                name: 'VOC_STATUS_NM',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.ACCEPT.DATE'),
                name: 'ACC_DT',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.ACCEPT.ACCEPTER'),
                name: 'ACC_USER_NM',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('FIELD.COMPLETED.DATE'),
                name: 'ANS_DT',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });
            column.push({
                header: SDLUtil.getMsgProp('TITLE.GLOBAL.ANSWERER'),
                name: 'ANS_USER_NM',
                align: 'center',
                width: 110,
                sortable: false,
                className: 'cur_pointer',
            });

            this.columns = column;
            this.gridKey++;
        },
        goListBack(data) {
            this.mode = 'list';
            this.onSearch(1);
        },
    },
    created() {
        EventBus.$on('goVocListBack', this.goListBack);
    },
    beforeDestroy() {
        EventBus.$off('goVocListBack');
    },
    mounted() {
        this.rangePicker = DatePicker.createRangeWithOpener(
            'fr-picker-container',
            'frDate',
            'icoFrDate',
            'to-picker-container',
            'toDate',
            'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            new moment().add(-1, 'month').toDate(),
            new moment().toDate(),
        );

        this.$nextTick(() => {
            this.country1 = this.loginRhq;
            this.country2 = this.corpCd;

            this.getCountryList1();
            this.getCountryList2();
            this.getCountryList3();

            this.getCommonCodeList('VOC_INQUIRY').then(data => {
                this.vocInquiryList = data;
            });
            this.getCommonCodeList('VOC_STATUS').then(data => {
                this.vocStatusList = data;
            });
            this.getColumn();
        });
    },
};
</script>

<style>
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/voc/RequestVocList.vue